module.exports = __webpack_public_path__ + "static/Larsseit-Medium-15413d0f0bb3224f762bf1711d5d1443.otf";